import React, { useState, useEffect } from 'react';
import { useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import saveIcon from "../components/img/images/save-icon.png";
import cancelIcon from "../components/img/images/close-icon.png";
import {ReactComponent as Clo_icon} from "../assets/close-icon.svg";
import {ReactComponent as Sav_icon} from "../assets/save-icon.svg";
function NewRecipeMachine() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get('userId');
  const machineId = queryParams.get('machineId');
  const [uId, setUId] = useState(userId);
  const [mId, setId] = useState(machineId);
  const [newRec, setNewRec] = useState(false);
  const [smallMedia, setSmallMedia] = useState(window.innerWidth <= 768); // Adjust breakpoint as needed
  const [preparationsSteps, setPreparationsSteps] = useState([]);
  const [recipeMainImages, setRecipeMainImages] = useState([]);
  const [garnishes, setGarnishes] = useState([]);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedImage2, setSelectedImage2] = useState(selectedImage);
  const [selectedImages, setSelectedImages] = useState([]);
  const [imageName, setImageName] = useState();
  const [supAdmin, setSupAdmin] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [selectedPreparations, setSelectedPreparations] = useState([]);
  const [showPreparationList, setShowPreparationList] = useState(false);
  const [prepId, setPrepId] = useState([]);
  const [garId , setGarId] = useState([]);
  const [showImageList, setShowImageList] = useState(false);
  const [getCats, setGetCats] = useState([]);
  const [ingredients, setIngredients] = useState([]);
  const [showDrop, setShowDrop] = useState(false);
  const [reName, setReName] = useState("");
  const [favorite, setFavorite] = useState(false);
  const [sellingPrice,setSellingPrice] = useState("");
  const [textArea, setTextArea] = useState("");
  const [cate,setCate] = useState("");
  const [getedCatId,setGetedCatId] = useState();
  const [selectedProduct, setSelectedProduct] = useState("");
  const [products, setProducts] = useState([]);
  const [total, setTotal] = useState(0);
  const [getCost, setGetCost] = useState(0);
  const [getId, setGetId] = useState();
  const [productValue, setProductValue] = useState("");
  const [singleCost, setSingleCost] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [classWidth, setClassWidth] = useState(0);
  const [classHeight, setClassHeight] = useState(0);
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const validateToken = async () => {
      const token = searchParams.get('token');
      if (!token) {
        navigate('/unauthorized'); // Redirect if no token is provided
        return;
      }

      try {
        const response = await axios.post('/api/validate-tokenRecipes', { token });
        if (!response.data.valid) {
          navigate('/unauthorized'); // Redirect if token is invalid
        }
      } catch (error) {
        console.error('Token validation failed:', error);
        navigate('/unauthorized'); // Redirect on error
      }
    };

    validateToken();
  }, [searchParams, navigate]);
  useEffect(() => {
    fetchCategories();
    fetchPumps();
    fetchGarnishes();
    fetchPrepSteps();
    fetchRecImages();
    renderPreparationImages();
    renderGarnishImages();  
    renderRecipeImages();
  }, [uId]);

  useEffect(() => {
      const handleResize = () => {
          setSmallMedia(window.innerWidth <= 768);
      };
  
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  //   Function to detect client screen w * h
  useEffect(() => {
    const updateDimensions = () => {
      const newWidth = window.innerWidth;
      const newHeight = window.innerHeight;
      setWidth(newWidth);
      setHeight(newHeight);
      const newClassWidth = newWidth;
      const newClassHeight = newClassWidth * 0.75;
      setClassHeight(768);
      setClassWidth(1024);
    };

    // Add event listener for resize event
    window.addEventListener('resize', updateDimensions);

    // Initial log
    updateDimensions();

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);
  useEffect(() => {
  }, [userId, machineId]);
  // Function to render the list of preparation images
  const renderPreparationImages = () => {
    return preparationsSteps.map((preparationsStep, index) => (
      <div className='prep-img-cont-both' onClick={() => handlePreparationClick(preparationsStep)}>
        <img
        key={index}
        alt="PreparationIcon"
        src={require(`../components/img/preparation/${preparationsStep.image}`)}
        className={`gar-img ${smallMedia ? 'gar-img-2' : ''}`}
      />
      <div className='prep-img-name'>{preparationsStep.steps}</div>
      </div>
      
    ));
  };
    // Function to render each garnish image
    const renderGarnishImages = () => {
      return garnishes.map((garnish, index) => (
        <div className='prep-img-cont-both'
        onClick={() => handleImageClick(garnish)}
        >
        <img
          key={index}
          alt="garnishIcon"
          src={require(`../components/img/Garnishes/${garnish.image}`)}
          className={`gar-img ${smallMedia ? "gar-img-2" : ""}`}
          
        />
        <div className='prep-img-name'>{garnish.name}</div>
        </div>
      ));
    };

  useEffect(() => {
    smallRecipesImages();
  }, [recipeMainImages]);
  const smallRecipesImages = () =>{
    if (recipeMainImages && recipeMainImages.length > 0) {
      const imageName = recipeMainImages[0].name;
      // Assuming the images are inside the 'img/image' directory
      setSelectedImage(require(`../..//img/image/${imageName}`));
      setSelectedImage2(require(`../..//img/image/${imageName}`));
      setImageName(imageName);
    }
  }
// Handle select and delete actions
const handleSelectImageR = (image) => {
  if (recipeMainImages && recipeMainImages.length > 0) {
    const imageName = image.name;
    // Assuming the images are inside the 'img/image' directory
    setSelectedImage(require(`../..//img/image/${imageName}`));
    setSelectedImage2(require(`../..//img/image/${imageName}`));
    setImageName(imageName);
  }
  
};
const handleDeleteImageR = async (id) => {
  const isConfirmed = window.confirm("Are you sure you want to delete this image?");
  
  if (isConfirmed) {
    try {
      const response = await fetch(`/api/delete-recipe-image/${id}`, {
        method: 'DELETE',
      });
      // alert(response);
      if (response.ok) {
        console.log("Image deleted successfully");
        
        setRecipeMainImages(prevImages => prevImages.filter(image => image.id !== id));
      } else {
        const errorData = await response.json();
        console.error("Failed to delete image:", errorData.message || "Unknown error");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  } else {
    console.log("Image deletion canceled");
  }
};
const handleUploadImageClick = () => {
  const fileInput = document.createElement("input");
  fileInput.type = "file";
  fileInput.accept = "image/*";
  fileInput.onchange = (event) => {
    const file = event.target.files[0];
    if (file) {
      uploadImage(file);
    }
  };
  fileInput.click();
};
const fetchRecImages = async () => {
  try {
    const response = await fetch('/api/getRecImages');
    if (!response.ok) {
      const errorMessage = await response.text();
      throw new Error('Network response was not ok: ' + errorMessage);
    }
    const data = await response.json();
    console.log("Fetched images:", data); // Log to verify the structure of the data
    setRecipeMainImages(data);
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};
const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append("image", file);

  try {
    const response = await fetch("/api/upload-recipe-image", {
      method: "POST",
      body: formData,
    });
    if (response.ok) {
      console.log("Image uploaded successfully");
      fetchRecImages(); // Refresh the image list after upload
    } else {
      const errorMessage = await response.text();
      console.error("Failed to upload image:", errorMessage); // Log specific error message
    }
  } catch (error) {
    console.error("Error during image upload:", error);
  }
};
const renderRecipeImages = () => {
  if (recipeMainImages.length === 0) {
    // If no images exist, show the "Upload Image" button (for admin users only)
    if (supAdmin === true) {
      return (
        <button 
          className="upload-img-button" 
          onClick={handleUploadImageClick}
        >
          Upload Image
        </button>
      );
    }
    return <div className='no-img-div'>No images available</div>; // Add a fallback message if no images are present
  } else {
    // If images exist, render them
    if (supAdmin === true) {
      return (
        <>
          {recipeMainImages.map((image, index) => (
            <div 
              key={index} 
              className="recipe-image-item" 
              onMouseEnter={() => setHoveredIndex(index)} 
              onMouseLeave={() => setHoveredIndex(null)}
              onClick={() => currentImage(image)}
            >
              <img 
                src={`/api/img/image/${image.name}`} 
                alt={`Recipe Image ${index}`} 
                className={`${smallMedia ? "loop-images-2" : "loop-images"}`}/>
              <p className='loop-image-names'>{image.name}</p>
        
              {/* Show buttons on hover */}
              {hoveredIndex === index && (
                <div className="overlay-buttons">
                  <button 
                    className="select-button" 
                    onClick={() => handleSelectImageR(image)}
                  >
                    Select
                  </button>
                  <button 
                    className="delete-button" 
                    onClick={() => handleDeleteImageR(image.id)}
                  >
                    Delete
                  </button>
                </div>
              )}
            </div>
          ))}
          
          {supAdmin && (
            <button 
              className="upload-img-button" 
              onClick={handleUploadImageClick}
            >
              Upload Image
            </button>
          )}
        </>
      );
    } else {
      return recipeMainImages.map((image, index) => (
        <div key={index} className="recipe-image-item" onClick={() => currentImage(image)}>
          <img 
            src={`/api/img/image/${image.name}`} 
            alt={`Recipe Image ${index}`} 
            className={`${smallMedia ? "loop-images-2" : "loop-images"}`} 
            onClick={() => currentImage(image)}
          />
          <p className='loop-image-names'>{image.name}</p>
        </div>
      ));
    }
  }
};
const handlePreparationClick = (preparation) => {
  const prepImage = preparation.image;
  const firstSplit = prepImage.split("/").pop();
  let p_name, p_extension;

  if (firstSplit.includes(".")) {
      const secondSplit = firstSplit.split(".");
      p_name = secondSplit[0];
      p_extension = secondSplit.pop();
  } else {
      p_name = firstSplit;
      p_extension = ''; // or null, depending on how you want to handle it
  }

  const imageName = p_name + (p_extension ? "." + p_extension : "");
  const imagePath = require(`../components/img/preparation/${imageName}`); 
  const preparationImage = {
      imageName: imagePath,
      name: p_name
  };
  const preparationsId = {
    id: preparation.id
  }

  // Check if preparation is already selected
  const isPreparationSelected = selectedPreparations.some(selected => selected.imageName === preparationImage.imageName);
  
  // If the preparation is already selected, do nothing
  if (isPreparationSelected) {
      return;
  }

  // Check if prepId already exists in the state
  if (prepId.includes(preparation.id)) {
      // If it exists, remove it from prepId
      setPrepId(prepId.filter(id => id !== preparationsId.id));
  } else {
      // Otherwise, add it to prepId
      setPrepId([...prepId, preparationsId]);
  }

  // Add the preparation to the selected preparations
  setSelectedPreparations([...selectedPreparations, preparationImage]);
  setShowPreparationList(false)
};
const handleImageClick = (garnishe) => {
  const imageNameF = garnishe.image;
  const firstSplit = imageNameF.split("/").pop();
  let p_name, p_extension;

  if (firstSplit.includes(".")) {
      const secondSplit = firstSplit.split(".");
      p_name = secondSplit[0];
      p_extension = secondSplit.pop();
  } else {
      p_name = firstSplit;
      p_extension = ''; // or null, depending on how you want to handle it
  }

  const imageName = p_name + (p_extension ? "." + p_extension : "");
  const imagePath = require(`../components/img/Garnishes/${imageNameF}`); 
  const garnishesImage = {
      imageName: imagePath,
      name: p_name
  };
  const garnisheshId = {
    id: garnishe.id
  }

  // Check if garnish is already selected
  const isGarnishSelected = selectedImages.some(selected => selected.imageName === garnishesImage.imageName);
  
  // If the garnish is already selected, do nothing
  if (isGarnishSelected) {
      return;
  }

  // Check if garId already exists in the state
  if (garId.includes(garnishe.id)) {
      // If it exists, remove it from garId
      setGarId(garId.filter(id => id !== garnisheshId.id));
  } else {
      // Otherwise, add it to garId
      setGarId([...garId, garnisheshId]);
  }

  // Add the garnish to the selected images
  setSelectedImages([...selectedImages, garnishesImage]);
  setShowImageList(false);
};
const fetchGarnishes = async () => {
  try {
    const response = await axios.get('/api/garnishes');
    // return response.data; // Assuming the server returns garnishes in JSON format
    setGarnishes(response.data);
  } catch (error) {
    console.error('Error fetching garnishes:', error);
    // return []; // Return empty array if there's an error
  }

};
  // Function to fetch all garnishes from Node.js server
  const fetchPrepSteps = async () => {
    try {
      const response = await axios.get('/api/prepsteps');
      // return response.data; // Assuming the server returns preparations in JSON format
      setPreparationsSteps(response.data);
    } catch (error) {
      console.error('Error fetching preparations:', error);
      // return []; // Return empty array if there's an error
    }
  
  };
  const fetchCategories = async () => {
    try {
      const response = await axios.get('/api/categories-data');
      setGetCats(response.data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };
  const fetchPumps = async () => {
    const macId = mId;
    try {
      const response = await axios.get(`/api/pump-data?userId=${uId}&macId=${macId || ''}`);
      setIngredients(response.data);
      // console.log(response.data);
    } catch (error) {
      console.error('Error fetching ingredients:', error);
    }
  };

  const currentImage = (selected) =>{
    // console.log(selected.name," This is full name");
    let nameOfImage = selected.name;
    setSelectedImage(require(`../..//img/image/${nameOfImage}`));
    setSelectedImage2(require(`../..//img/image/${nameOfImage}`));
    // console.log(selected);
    setShowDrop(false);
    // const spArray = selected.name.split(".");
    // console.log("sllited name ",spArray);
    
    const iNA = selected.name;
    // console.log(iNA, "final name");
    setImageName(""+iNA+"")
  }
  const showContainer = () =>{
    setShowDrop(true);
  }
  const handleRemovePreparation = (selectedImageToRemove) => {
    setSelectedImages(selectedImages.filter(selectedImage => selectedImage !== selectedImageToRemove));
  };
  
  const handleRemovePrep = (selectedPreparationToRemove) => {
    setSelectedPreparations(selectedPreparations.filter(selectedPreparation => selectedPreparation !== selectedPreparationToRemove));
  };
  const handleAddProduct = () => {
    // Check if the product already exists
    const isProductExists = products.some(product => product.name === selectedProduct);

    if (isProductExists) {
      alert(`${selectedProduct} is already added.`);
      return; // Do not proceed further
    }
    if (selectedProduct && productValue && getId) {

          // Check if the product already exists
      const isProductExists = products.some(product => product.name === selectedProduct);
      
      if (isProductExists) {
        alert(`${selectedProduct} is already added.`);
        return; // Do not proceed further
      }
      // console.log(selectedProduct+' '+productValue+''+getId+ ' this is set to send to products');
      const newProduct = {
        id: getId,
        name: selectedProduct,
        value: parseFloat(productValue),
        cost_ml: getCost,
        t_cost: getCost * parseFloat(productValue),
      };
    const currentSingleCost = getCost * productValue;
    // Update single cost
    setSingleCost(currentSingleCost);

    // Update grand total by adding single cost to existing total
    setGrandTotal(prevTotal => prevTotal + currentSingleCost); 
      setProducts([...products, newProduct]);
      setTotal(total + parseFloat(productValue));
      setSelectedProduct("");
      setProductValue("");
      // setGetCost();
      setGetId();
      setSingleCost();

    }else{
      alert("Select Both Name and Quantity!");
    }
  };
  const handleClose = () => {
    setProducts([]);
    setSelectedImages([]);
  }
  const handleDeleteProduct = (index) => {
    // console.log(index);
    // console.log(grandTotal + ' This is delete button grandtotal');
    const deletedProduct = products[index];
    console.log(products[index]);
    const { value: deletedValue } = deletedProduct;
    // console.log(deletedValue + " taken delete product form list");
    const deletedCost = products[index].t_cost;
    console.log(deletedCost + ' this is current single cost to delete');
    const updatedTotal = grandTotal - deletedCost;
    const upperTotal = parseFloat(updatedTotal);
    setGrandTotal(updatedTotal);
    
    const updatedProducts = [...products];
    updatedProducts.splice(index, 1);
    setProducts(updatedProducts);
  
    // // Check if there are no products left
    if (updatedProducts.length === 0) {
      // Set the grand total to 0
      setGrandTotal(0);
    }
  };
  const backTblNN = () => {
    const uUid = uId;
    const selectedIName1st = selectedImage2.split("/").pop();
    const selectedIName2nd1 = selectedIName1st.split(".")[0];
    const selectedIName2nd2 = selectedIName1st.split(".").pop();
    const selectedIName = selectedIName2nd1 + "." + selectedIName2nd2;
    // Prepare the data to send to the server
    const dataToSend = {
        total: total,
        mIds:mId,
        reName: reName,
        favorite: favorite,
        textArea: textArea,
        sellingPrice: sellingPrice,
        cate: cate,
        getedCatId: getedCatId,
        grandTotal: grandTotal,
        selectedPreparations: selectedPreparations.map(preparation => preparation.name),
        selectedPreparationsImages: selectedPreparations.map(preparation => preparation.name + ".png"),
        selectedImages: selectedImages.map(image => image.name),
        selectedGarId: garId.map(gar => `${gar.id}`),
        selectedPrepId: prepId.map(prep => `${prep.id}`),
        selectedImagesName: selectedImages.map(image => image.name + ".png"),
        selectedIName: selectedIName,
        products: products.map(product => `${product.id} ${product.value}`)
    };
    
  // Check if any field in dataToSend is null, excluding the 'favorite' field
  const isAnyFieldEmpty = Object.entries(dataToSend).some(([key, value]) => key !== 'favorite' && !value);

  if (isAnyFieldEmpty) {
      alert("All fields except 'favorite' are required.");
      return; // Exit the function if any non-favorite field is empty
  }

    // Send the data to the server
    axios.post(`/api/new-recipe/${uUid}`, dataToSend)
        .then(response => {
            alert(response.data); // Log the response from the server
        })
        .catch(error => {
            console.error('Error sending data to server:', error);
        });
    setProducts([]);
    setTextArea("");
    setSelectedPreparations([]);
    setSelectedImages([]);
    setSellingPrice("");
    setFavorite(false);
    setCate("Choose Categorie");
    if(recipeMainImages.length !== 0){
      setSelectedImage(recipeMainImages[0].name);
      setSelectedImage2(selectedImage);
    }
    
    setGrandTotal(0);
}
  return (
    <div className="dashboardF" style={{height: `${classHeight}px`,width: `${classWidth}px`}}>
    <div className="sp-recipes" style={{padding: '2%'}}>
    <div className={` ${smallMedia ? "new-r-p2" : "new-r-p"}`} style={{ border: '1px solid #EF7C32', padding:"1%", borderRadius:'10px'}}>
    <div className={` ${smallMedia ? 'sub-class-2a' : 'sub-class'}`}>
    <div className={` ${smallMedia ? "vertical-div1-2" : "vertical-div1"}`}>
      <div className={` ${smallMedia ? "t-main-div-2" : "t-main-div"}`}>
      <div className={` ${smallMedia ? "mainpic-2" : "mainpic"}`}style={{display: 'flex', justifyContent: 'center', }}  >
      <div className={` ${smallMedia ? "shadeTriangle-imageL" : "shadeTriangle-imageL-2"}`} style={{position: 'absolute', marginLeft: '-100%'}} ></div>
        <img src={selectedImage2} alt="image" className="selected-image" style={{width: 'auto', height: "100%"}} />
      </div>
      </div>
      {/* <div className="images-container"> */}
        <div className={` ${smallMedia ? "drop-imge-2" : "drop-imge"}`} style={{display: showDrop ? "block": "none"}}>
          {renderRecipeImages()}
        </div>
        <div className={` ${smallMedia ? "t-main-div2-2" : "t-main-div2"}`} >
          <div  className={` ${smallMedia ? "selectImage-2" : "selectImage"}`} onClick={showContainer} style={{display: 'flex', justifyContent: 'center' }} >
            <div className={` ${smallMedia ? "shadeTriangle-image-2" : "shadeTriangle-image"}`} style={{position: 'absolute', marginLeft: '-100%'}} ></div>
          <img src={selectedImage} alt="icon" className="drop-image" style={{width: 'auto', height: "100%"}} />
          </div>
          <div className={` ${smallMedia ? "selectedName-2" : "selectedName"}`} style={{marginTop: '15.5%'}}>
            <div className={` ${smallMedia ? "nameLeft-2" : "nameLeft-aab"}`}></div>
            <div className='name-inpt'>
            <input type="text" readOnly className={` ${smallMedia ? "select-I-N-2" : "select-I-N"}`} value={imageName} />
            </div>
          <div className={` ${smallMedia ? "nameRight-2" : "nameRight-aab"}`}></div>
          </div> 
        </div>
    </div>
    {/* </div> */}
    <div className={` ${smallMedia ? "vertical-div2-2" : "vertical-div2"}`}>
    <div className={` ${smallMedia ? "div2-1-2" : "div2-1"}`}>
    <div className="full-name">
    <div className="f-name sm-txt-a">Name </div>
    <div className={` ${smallMedia ? "recipe-name-2" : "recipe-name"}`}>
      <div className={` ${smallMedia ? "nameLeft-2" : "nameLeft-b"}`}></div>
      <input type="text" value={reName} 
      className={`${smallMedia ? 're-name' : 're-name-2'}`} 
      onChange={(event) => setReName(event.target.value)} 
      placeholder="Enter name" />
      <div className={` ${smallMedia ? "nameRight-2" : "nameRight-b"}`}></div>
      </div>
    </div>
    <div className={`${smallMedia ? "favorite-btn-2" :'favorite-btn' }`} style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
    <div className=''>Favorite</div>
    <div className="customDiv" onClick={()=>{setFavorite(false)}} style={{display : favorite ? 'block' : 'none'}} >
    <div className={` ringF ${smallMedia ? "ringF-2" :'' }`} style={{marginLeft:'43%'}}>
      <div className='dotF'></div>
    </div>
    </div>

    <div className="customDiv" onClick={()=>{setFavorite(true)}} style={{display : favorite ? 'none' : 'block', paddingLeft: '17%'}} >
    <div className='ringFf'></div>
    </div>
    </div>
    </div>
    <div className={` ${smallMedia ? "div2-2-2" : "div2-2"}`}>
    <div className='pre-container'>
    <div className="pre-head sm-txt-a">Preparation</div>    
  <div  className={`image-selector-button ${smallMedia ? "image-selector-button-2" : ""}`}>
    <div className={` ${smallMedia ? "nameLeft-2" : "nameLeft-a"}`}></div>
    <div className={`${smallMedia ? "pre-text-box-2" : "pre-text-box"}`} onClick={() => setShowPreparationList(!showPreparationList)}>
{selectedPreparations.length === 0 ? (
  <div className='st-txt'>Select Steps...</div>
) : (
  <div className='selected-prep-container'>
    {selectedPreparations.map((selectedPreparation, index) => (
      <div className={`selected-div ${smallMedia ? "selected-div-2" : ""}`}  key={index}>
        <div className='sele-image'>
          <img key={index} src={selectedPreparation.imageName} alt={`Selected Preparation ${index}`} className="selected-prep" />
        </div>
        <div className='sele-name'>
          <label>{selectedPreparation.name}</label>
        </div>
        <div className='mCl'>
          <div className="closeP" onClick={() => handleRemovePrep(selectedPreparation)}>x</div>
        </div>
      </div>
    ))}
  </div>
)}
</div>
    <div className={` ${smallMedia ? "nameRight-2" : "nameRight-a"}`}></div>
  </div>
   <div className={'prep-cont-active'} style={{display: showPreparationList ? 'block' : 'none'}}>
      <div className={`image-list ${smallMedia ? 'image-list-2' : ''}`}>
        {renderPreparationImages()}
      </div>
    </div>
    </div> 
    <div className="garnishes" >
      <div className="pre-head sm-txt-a">Garnishes</div>
      <div className={`image-selector-button ${smallMedia ? "image-selector-button-2" : ""}`} onClick={() => setShowImageList(!showImageList)}>
      <div className={` ${smallMedia ? "nameLeft-2" : "nameLeft-a"}`}></div>
      <div className={`${smallMedia ? "pre-text-box-2" : "pre-text-box"}`}>
        {selectedImages.length === 0 ? (
          <div className='st-txt'>Select Garnishes...</div>
        ) : (
          <div className='selected-prep-container'>
            {selectedImages.map((selectedImage, index) => (
            <div className={`selected-div ${smallMedia ? "selected-div-2" : ""}`} key={index}>
              <div className='sele-image'>
              <img src={selectedImage.imageName} alt={`Selected Preparation ${index}`} className="selected-prep" />
              </div>
              <div className='sele-name'>
              <label>{selectedImage.name}</label>
              </div>
              <div className='mCl'>
              <div className="closeP" onClick={() => handleRemovePreparation(selectedImage)}>x</div>
              </div>
            </div>
          ))}
          </div>
        )}
      </div>

        <div className={` ${smallMedia ? "nameRight-2" : "nameRight-a"}`}></div>
      </div>
     <div className={'prep-cont-active'} style={{display: showImageList ? 'block' : 'none'}}>
      <div className={`image-list ${smallMedia ? "image-list-2" : ""}`}>
        {renderGarnishImages()}
      </div>
      </div>
    </div>

    </div>
    <div className={` ${smallMedia ? "div2-3-2" : "div2-3"}`}>
    <div className="proc-head">Procedure</div>
      <div className={` ${smallMedia ? "procedure-2" : "procedure"}`}>
    <div  className={`${smallMedia ? 'textLeft' : 'textLeft-2'}`}></div>
      <div className="text-area">
      <textarea name="postContent" className={`${smallMedia ? 'textarea-box' : 'textarea-box-2'}`} onChange={(event) => setTextArea(event.target.value)} value={textArea} placeholder="Type Procedure..." />
      </div>
    <div  className={`${smallMedia ? 'textRight' : 'textRight-2'}`}></div>
      </div>
    </div>
    <div className={` ${smallMedia ? "div2-4-2" : "div2-4"}`}>
      <div className= "selling-p">
        <div className="se-head sm-txt-a">Selling Price</div>
        <div className= {`  ${smallMedia ? "selling-area-2" : "selling-area"}`}>
        <div className={` ${smallMedia ? "nameLeft-2" : "nameLeft-aab"}`}></div>
        <div className="sell-input">
          <input type="number"  
          className={`${smallMedia ? 'sell-text-box' : 'sell-text-box-2'}`}
          onChange={(event) => setSellingPrice(event.target.value)} value={sellingPrice} placeholder="Selling Price"/>
        </div>
        <div className={` ${smallMedia ? "nameRight-2" : "nameRight-aab"}`}></div>

        </div>
      </div>
      <div className="categories">
          <div className="ce-head sm-txt-a">Categories</div>
          <div className={` ${smallMedia ? "cate-box-2" : "cate-box"}`}>
        <div className={` ${smallMedia ? "nameLeft-2" : "nameLeft-a"}`}></div>
        <div className="cate-select-box"> 
      <select
      value={cate}
      onChange={(e) => {
        setCate(e.target.value);
        const selectedCategory = getCats.find(getCats => getCats.name === e.target.value);
        if (selectedCategory) {
          setGetedCatId(selectedCategory.id)
        }
      }}
      className="select-cate" >
        <option>Choose Categorie</option>
        {getCats.map((getCat, index) => (
          <option key={index} value={getCat.name}>{getCat.name}</option>
        ))}
        </select> 

        </div>
        <div className={` ${smallMedia ? "nameRight-2" : "nameRight-a adjst"}`}></div>
          </div>
      </div>
    </div>
    </div>
    </div>
    <div className={` ${smallMedia ? "dynamic-table-2" : "dynamic-table"}`}>

    <div className={` ${smallMedia ? "choose-p-2" : "choose-p"}`}>
    <div className={`choosing-pro ${smallMedia ? "choosing-pro-2" : ""}`}>
    <div className="product-choose">
      <div className="cho-head sm-txt-a">Name</div>
      <div className={`choose-box ${smallMedia ? "choose-box-2" : ""}`}>
        <div className={` ${smallMedia ? "nameLeft-2" : "nameLeft-ac"}`}></div>
        <select
          value={selectedProduct}
          onChange={(e) => {
            setSelectedProduct(e.target.value);
            const selectedIngredient = ingredients.find(ingredient => ingredient.ingredient_name === e.target.value);
            if (selectedIngredient) {
              setGetCost(selectedIngredient.cost_ml);
              setGetId(selectedIngredient.ing_id);
            }
          }}
          className="choosen-prod"
        >
          <option>Select Name ...</option>
          {ingredients.map((ingredient, index) => (
            <option key={index} value={ingredient.ingredient_name}>{ingredient.ingredient_name}</option>
          ))}
        </select>
        <div className={` ${smallMedia ? "nameRight-2" : "nameRight-ac"}`}></div>
      </div>
    </div>
    <div className="product-q" >
      <div className='qty-head sm-txt-a'>Quantity(ml)</div>
      <div className={` p-q-cont ${smallMedia ? "p-q-cont-2" : ""}`}>
        <div className="p-q-cont-left"></div>
        <div className="quantity-area">
          <input
            type="number"
            value={productValue}
            onChange={(e) => setProductValue(e.target.value)}
            placeholder="Quantity"
            className={`${smallMedia ? "quantity-te-2" : "quantity-te"}`}
          />
        </div>
        <div className="p-q-cont-right"></div>
      </div>
    </div>
    <div className="product-a" >
      <div className='qty-head sub-cl2 sm-txt-a'>Action</div>
      <div className={`${smallMedia ? "p-a-btn-2" : "p-a-btn"}`} onClick={handleAddProduct}>
        <div className={`${smallMedia ? "shadeTriangle-quan-2" : "shadeTriangle-quan"}`}></div>
        <button className="add-btn">
          <span className="sub-symb">+</span>Add
        </button>
      </div>
    </div>
    {/* <p>Single Cost: {singleCost}</p>
    <p>Grand Total: {grandTotal}</p> */}
  </div> 
    {/* <p>Total Cost: {totalCost}</p> */}
  <div style={{display: smallMedia ? 'none' : 'block'}} className='allBtns'>
    <div className="btnClose"  >
    <div className='total-ml' style={{height: '150%', marginTop: '-5.5%'}}>
    <label className='sm-txt-a'>Total(ml)</label>
    <div className="recal-btn-2">
    <div className="nameLeft-acca"></div>
    {/* <div className='shadeTriangle-recal-2 adjust-3'></div> */}
    <button className="recycle-btn"> {total} </button>
    <div className="nameRight-acca"></div>
    </div>
    </div>
    
      <div className="new-close-cont-2" onClick={handleClose}>
          <div className='shadeTriangle-recal-2'></div>
        <button  className="close-btn">
        <label className='close-icon-2'>
          <Clo_icon className='sp-icon'/>
        </label>
        Close
        </button>
      </div>
      <div className="new-close-cont-2" onClick={backTblNN}>
      <div className='shadeTriangle-recal-2'></div>
      <button  className="close-btn">
      <label className='close-icon-2'>
      <Sav_icon className='sp-icon'/>
        </label>
      {/* <img src={saveIcon} alt="icon" className="close-icon-2" /> */}
      Save</button>
      </div>
    </div>
    </div>
    </div>
    <div className={` ${smallMedia ? "only-table-2" : "only-table"}`}>
    {/* <h2>Product Table</h2> */}
    <table className="product-t" style={{borderCollapse: "separate"}}>
      <tbody className='custombody'>
        {products.map((product, index) => (
          <tr key={index} className="data-loop">
            {/* <div className='for-re'> */}
            <div className={`t-data c-name ${smallMedia ? "t-name-2" : "t-name"}`} >
            <div className={` ${smallMedia ? "nameLeft-2" : "nameLeft-ca"}`}></div>
            <div  className={` p-table-name ${smallMedia ? "p-table-name-2" : ""}`}>
            <td className='dy-name'>
            {product.name}</td>
            </div>
            <div className={` ${smallMedia ? "nameRight-2" : "nameRight-ca"}`}></div>
            </div>
            {/* </div> */}
            <div className={`t-data ${smallMedia ? "t-quantity-2" : "t-quantity"}`} >
              <div
              className={`${smallMedia ? "shadeTriangle-quan-2" : "shadeTriangle-quan"}`} 
              ></div>
            <div  className={`p-table-quantity ${smallMedia ? "p-table-quantity-2" : ""}`} >
            <td>{product.value}</td>
            </div>
            </div>
            <div className={`t-data ${smallMedia ? "t-action-2" : "t-action"}`} >
            <div className={`${smallMedia ? "shadeTriangle-quan-2" : "shadeTriangle-quan"}`}></div>
            <div className="p-t-a-btn">
            <td>
              <button onClick={() => handleDeleteProduct(index)} className="p-btn">
                <span className='span-del'>Del</span>
              </button>
            </td>
            </div>
            </div>
          </tr>
        ))}
      </tbody>
      {/* <tfoot>
        <tr>
          <td colSpan="2">Total:</td>
          <td>{total}</td>
        </tr>
      </tfoot> */}
    </table>
    <div style={{display: smallMedia ? 'block' : 'none'}}>
    <div className={` ${smallMedia ? "btnClose-2" : "btnClose"}`} >
    <div className="recal-btn">
    <div className="recal-Left"></div>
    {/* <div className='shadeTriangle-recal'></div> */}
    <button className="recycle-btn"> {total} </button>
    <div className="recal-Right"></div>
    </div>
      <div className="new-close-cont" onClick={handleClose}>
          <div className='shadeTriangle-recal'></div>
        <button  className="close-btn">
        <img src={cancelIcon} alt="icon" className="close-icon" />
        Close
        </button>
      </div>
      <div className="new-close-cont" onClick={backTblNN}>
      <div className='shadeTriangle-recal'></div>
      <button  className="close-btn">
      <img src={saveIcon} alt="icon" className="close-icon" />
      Save</button>
      </div>
    </div>
    </div>
    </div>
    </div>
  </div>
  </div>
  </div>
  );
}

export default NewRecipeMachine;
